import {types} from 'mobx-state-tree';

export enum ListingProviderType {
  AIRBNB = 'airbnb.com',
  BOOKING = 'booking.com',
  VRBO = 'vrbo.com',
  AGODA = 'agoda.com',
  EXPEDIA = 'expedia.com',
  TRAVELOKA = 'traveloka.com',
  COHOST_CLUB = 'cohost.club',
  FACEBOOK = 'facebook.com',
  INSTAGRAM_COM = 'instagram.com',
  LUXSTAY_COM = 'luxstay.com',
  WAKA_LIFE = 'waka.life',
  TUJIA_COM = 'tujia.com',
  TRIPADVISOR_COM = 'tripadvisor.com',
  MISTERBANDB_COM = 'misterbandb.com',
  TIKTOK_COM = 'tiktok.com',
  WHATS_APP_COM = 'whatsapp.com',
  VIBER_COM = 'viber.com',
  HOTEL_RUNNER_COM = 'hotelrunner.com',
  EMAIL = 'email',
  PHONE = 'phone',
  ZALO_ME = 'zalo.me'
}

export enum ReservationStateType {
  CONFIRMED = 'CONFIRMED',
  CHANGED = 'CHANGED',
  CANCELLED = 'CANCELLED',
  REQUESTED = 'REQUESTED',
  CHANGE_REQUESTED = 'CHANGE_REQUESTED',
  PASSED = 'PASSED'
}

export const ListingProvider = types.enumeration<ListingProviderType>(
  Object.keys(ListingProviderType).map(key => ListingProviderType[key])
);

export const ReservationState = types.enumeration<ReservationStateType>(
  Object.keys(ReservationStateType).map(key => ReservationStateType[key])
);



// WEBPACK FOOTER //
// ./src/models/enums/index.ts